/**
 * @desc 删除用户
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.UserIDParameter): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/auth/user/delete',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
